<template>
  <div id="home-page">
    <div
      id="home-page-scalable"
      class="home-page-scalable"
      :style="{
        transform: 'translate(-50%, -50%) scale(' + scale + ')',
      }"
    >
      <video :autoplay="true" muted loop id="video-bcg" v-if="bcgVideo">
        <source :src="bcgVideo.webm" type="video/webm" />
        <source :src="bcgVideo.mp4" type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
      <img id="home-page-bcg" v-if="bcg" :src="bcg" />
      <img id="home-page-header" v-if="homePageData.header" :src="homePageData.header" />
      <div id="home-page-down" v-if="homePageData.header"></div>
      <mb-media-bar v-if="homePageData.mediaBar"></mb-media-bar>
      <div class="home-page-box">
        <p
          class="home-page-text"
          :key="'home-page-text-' + index"
          v-for="(txt, index) in homePageData.text"
          :style="txt.cssStyle"
          v-html="txt.content"
          @click="openUrl(txt.url)"
        ></p>
        <div
          class="home-page-box-item"
          :key="'multibook-type' + index"
          v-for="(it, index) in homePageData.multibooks"
          :class="{ 'home-page-disable-item': it.disable }"
          :style="[{ width: (100 - 10) / homePageData.multibooks.length + '%', zIndex: it.zIndex }, it.cssStyle]"
        >
          <img class="home-page-img" :src="it.bcg" :style="setScale(index, it.additionalTransform)" />
          <div
            class="home-page-mask"
            :style="[setScale(index, it.additionalTransform), { 'clip-path': 'polygon(' + it.mask + ')' }]"
            @click="redirectDev(it.name, it.router, it.disable, it.filePath, it.items, homePageData.header)"
            @mouseenter="hoverOnSet(index)"
            @mouseout="hoverOnSet(-1)"
            @mouseleave="hoverOnSet(-1)"
          ></div>
        </div>
      </div>
      <img
        :key="'additional-img-' + indexAdd"
        v-for="(add, indexAdd) in additionalImages"
        @click="openUrl(add.href)"
        :src="add.src"
        :style="{
          width: add.width + '%',
          zIndex: add.zIndex,
          position: 'absolute',
          top: add.top + '%',
          left: add.left + '%',
        }"
      />
      <div
        @click="
          audioClick.play();
          showInfo = !showInfo;
        "
        class="new-info-btn"
      >
        <img :src="infoIcon" alt="Info" class="new-icon" draggable="false" />
      </div>
      <info-page
        v-if="infoPage && !infoPage.hide"
        :showinfo="showInfo"
        :infopage="infoPage"
        @exitInfo="showInfo = false"
      ></info-page>
    </div>
  </div>
</template>
<script>
import InfoPage from './InfoPage.vue';
import home from '__mainSrcDir/config/homePage/homePage.js';
import MbMediaBar from '../MbMediaBar/MbMediaBar';
import { Howler } from 'howler';
export default {
  name: 'home-page',
  components: { MbMediaBar, InfoPage },
  props: {
    runBook: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      infoPage: null,
      showInfo: false,
      scale: 1,
      bcg: null,
      bcgVideo: null,
      homePageData: null,
      additionalImages: null,
      hoverOn: -1,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'main_book-view' && to.params.runBook) {
      next((vm) => {
        let link = to.params.runBook || '';
        vm.open(link);
        vm.$router.push('/');
      });
    }
    next();
  },
  created() {
    this.resizeWindow();
  },
  beforeMount() {
    this.init();
  },
  mounted() {
    window.addEventListener('resize', this.resizeWindow);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  methods: {
    resizeWindow(e) {
      const { innerWidth, innerHeight } = window;
      this.scale = Math.min(innerWidth / 1920, innerHeight / 1080);
    },
    openUrl(link) {
      if (link) {
        if (this.$store.getters.isWeb) {
          window.open(link, '_blank');
        } else {
          this.$electron.shell.openExternal(link);
        }
      }
    },
    hoverOnSet(index) {
      this.hoverOn = index;
    },
    setScale(index, additionalTransform) {
      if (index == this.hoverOn) {
        if (additionalTransform) return { transform: 'scale(1) ' + additionalTransform };
        else return { transform: 'scale(1)' };
      } else {
        return {};
      }
    },
    redirectDev(type, router, disable, filePath, elements, header) {
      if (!disable) {
        if (elements && header) elements.header = header;
        if (router && type != 'main_book') {
          this.audioClick.play();
          this.$store.commit('CHANGE_MULTIBOOK_TYPE', type);
          this.$router.push({ name: router, params: { items: elements } });
        } else if (type === 'main_book') {
          this.audioClick.play();
          this.$router.push({ name: 'main_book-view', params: { runBook: process.env.MAIN_BOOK_PATH } });
        } else if (type === 'file') {
          this.audioClick.play();
          this.$router.push({ name: 'main_book-view', params: { runBook: filePath } });
        } else {
          this.audioClick.play();
          this.$router.push({ name: 'page-view', params: { id: '-1', multibookType: `${type}` } });
        }
      }
    },
    open(link) {
      const path = require('path');
      let fullLink;
      let base;
      if (!this.$store.getters.isWeb) {
        if (require('os').platform() === 'win32') {
          console.log('WIN32');
          base = path.win32.resolve();
        } else {
          console.log('LINUX');
          base = path.posix.resolve();
        }
        if (process.env.NODE_ENV != 'development') {
          fullLink = path.join(base, '/../' + link);
        } else {
          fullLink = path.join(base, link);
        }
        this.$electron.shell.openItem(fullLink);
      } else {
        let tmplink = link;
        let url = document.createElement('a');
        url.href = '/static/' + tmplink;
        url.download = tmplink.substr(tmplink.lastIndexOf('/') + 1);
        url.click();
      }
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    checkSeason(d) {
      let seasonArray = [
        { name: 'spring', date: new Date(d.getFullYear(), 2, d.getFullYear() % 4 === 0 ? 21 : 22).getTime() },
        { name: 'summer', date: new Date(d.getFullYear(), 5, d.getFullYear() % 4 === 0 ? 22 : 23).getTime() },
        { name: 'autumn', date: new Date(d.getFullYear(), 8, d.getFullYear() % 4 === 0 ? 23 : 24).getTime() },
        { name: 'winter', date: new Date(d.getFullYear(), 11, d.getFullYear() % 4 === 0 ? 22 : 23).getTime() },
      ];

      const season = seasonArray.filter(({ date }) => date <= d).slice(-1)[0] || { name: 'winter' };
      return season.name;
    },
    init() {
      try {
        this.infoPage = require('../../config/infopage');
      } catch (e) {
        console.info(e);
      }
      try {
        this.audioClick = new Howl({
          src: require(`__mainSrcDir/assets/audio/click.mp3`),
          autoplay: false,
          loop: false,
          volume: 0.5,
        });
      } catch (e) {
        console.log(
          '%cAudioPath HomePage- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      this.homePageData = home;
      if (this.homePageData.seasonCheck) {
        // console.log(new Date());
        let season = this.checkSeason(new Date());
        this.homePageData.configs.forEach((it) => {
          if (it.id == season) {
            this.homePageData.video = it.video;
            this.homePageData.header = it.header;
            this.homePageData.additionalImages = it.additionalImages;
          }
        });
      }
      if (Array.isArray(this.homePageData.bcg)) {
        let tmp = this.shuffle(this.homePageData.bcg);
        this.bcg = tmp[0];
      } else {
        this.bcg = this.homePageData.bcg;
      }
      if (Array.isArray(this.homePageData.header)) {
        let tmp = this.shuffle(this.homePageData.header);
        this.homePageData.header = tmp[0];
      }
      if (Array.isArray(this.homePageData.video)) {
        let tmp = this.shuffle(this.homePageData.video);
        this.bcgVideo = tmp[0];
      } else {
        this.bcgVideo = this.homePageData.video;
      }
      if (this.homePageData.additionalImages) {
        this.additionalImages = this.homePageData.additionalImages;
      }
    },
  },
  computed: {
    infoIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/pikto_info.svg`);
      } catch {
        console.log(
          '%cInfoIcon HomePage- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
$break-large: 1400px
#home-page
  width: 100vw
  height: calc(var(--vh, 1vh) * 100)
  background: white
  background-size: cover
  #home-page-scalable
    width: 1920px
    height: 1080px
    top: 0
    left: 0
    background: white
    text-align: center
    position: relative
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    transform-origin: center center
  #home-page-bcg
    object-fit: contain
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0
  #home-page-header, #home-page-down
    box-shadow: 0px 1px 7px rgba(0,0,0, 0.2)
    // object-fit: contain
    position: absolute
    width: 100%
    // height: 100vh
    top: 0
    left: 0
  #home-page-down
    top: 95%
    background: white
    height: 5%
    bottom: 0
  #video-bcg
    position: absolute
    right: 0
    bottom: 0
    width: 100%
    height: 100%
  .home-page-box
    width: 100%
    height: 100%
    display: flex
    flex-direction: row
    position: absolute
    top: 0
    left: 0
    align-items: center
    justify-content: center
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
    .home-page-box-item
      // $root: &
      // max-width: 80%
      // max-height: 80%
      .home-page-mask
        background: transparent
        position: absolute
        top: 0
        width: 100%
        height: 100%
        cursor: pointer
        transform: scale(.8)
        transition: .5s
        z-index: 15
      .home-page-clip-path
        width: 100%
        height: 100%
        top: 0
        position: absolute
        background: transparent
        clip-path: polygon(0% 0%, 0% 100%, 31% 100%, 34% 27%, 71% 30%, 71% 71%, 31% 73%, 27% 100%, 100% 100%, 100% 0%)
      .home-page-img
        width: 100%
        height: 100%
        transform: scale(.8)
        transition: .5s

    .home-page-disable-item
      filter: grayscale(1) !important
      img
        transform: scale(.8) !important
        cursor: auto
        &:hover
          transform: scale(.8) !important
.media-bar-fade-leave-active, .media-bar-fade-enter-active
  transition: all .5s ease-in-out
.media-bar-fade-leave-to, .media-bar-fade-enter
  transform: translateX(-110%)
  opacity: 0
.new-info-btn
  position: absolute
  z-index: 2
  top: 3%
  right: 0.15%
  width: 5%
  height: 5%
  cursor: pointer
  transition: 0.5s
  &:hover
    transform: scale(1.2)
  .new-icon
    width: 100%
    height: 100%
</style>
